import React from "react";
import Gauge from "./Gauge";

export default function OnlineAd({ data = {} }) {
  return (
    <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4  py-2 px-4">
      <h3 className="text-text-700 my-2 mb-4  text-[16px] font-semibold">
        Online Advertisement
      </h3>
      <div className="flex py-4 space-x-4 mb-2 px-4 justify-evenly border rounded-[14px] overflow-hidden border-input  bg-gray-50 relative mt-4 py-2">
        <div className="w-full space-y-3">
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
              fill="var(--blue-dark-50)"
            />
            <path
              d="M19.1351 23.189L15.3304 16.3805C14.8929 15.5976 14.6742 15.2062 14.711 14.8857C14.7432 14.6061 14.8917 14.353 15.1201 14.1885C15.3819 14 15.8303 14 16.7271 14H18.9619C19.2952 14 19.4619 14 19.6114 14.0481C19.7436 14.0907 19.8656 14.1604 19.9694 14.2528C20.0867 14.3571 20.1713 14.5007 20.3405 14.7879L24.0001 21L27.6597 14.7879C27.8289 14.5007 27.9135 14.3571 28.0308 14.2528C28.1347 14.1604 28.2566 14.0907 28.3889 14.0481C28.5383 14 28.705 14 29.0383 14H31.2731C32.1699 14 32.6183 14 32.8801 14.1885C33.1085 14.353 33.257 14.6061 33.2892 14.8857C33.326 15.2062 33.1073 15.5976 32.6698 16.3805L28.8651 23.189M22.5001 26L24.0001 25V30M22.7501 30H25.2501M28.5963 22.9038C31.1347 25.4422 31.1347 29.5578 28.5963 32.0962C26.0579 34.6346 21.9423 34.6346 19.4039 32.0962C16.8655 29.5578 16.8655 25.4422 19.4039 22.9038C21.9423 20.3654 26.0579 20.3654 28.5963 22.9038Z"
              stroke="var(--blue-dark-500)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div>
            <h4 className="text-sm text-gray-600">Average Ad Rank</h4>
            <h4 className="text-xl text-gray-900 font-bold  mt-2">
              {data?.average_ad_rank ? data?.average_ad_rank : "-"}
            </h4>
          </div>
        </div>
        <div className="w-full space-y-3">
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
              fill="var(--blue-dark-50)"
            />
            <path
              d="M21 24H16.6C16.0399 24 15.7599 24 15.546 24.109C15.3578 24.2049 15.2049 24.3578 15.109 24.546C15 24.7599 15 25.0399 15 25.6V31.4C15 31.9601 15 32.2401 15.109 32.454C15.2049 32.6422 15.3578 32.7951 15.546 32.891C15.7599 33 16.0399 33 16.6 33H21M21 33H27M21 33L21 20.6C21 20.0399 21 19.7599 21.109 19.546C21.2049 19.3578 21.3578 19.2049 21.546 19.109C21.7599 19 22.0399 19 22.6 19H25.4C25.9601 19 26.2401 19 26.454 19.109C26.6422 19.2049 26.7951 19.3578 26.891 19.546C27 19.7599 27 20.0399 27 20.6V33M27 33H31.4C31.9601 33 32.2401 33 32.454 32.891C32.6422 32.7951 32.7951 32.6422 32.891 32.454C33 32.2401 33 31.9601 33 31.4V16.6C33 16.0399 33 15.7599 32.891 15.546C32.7951 15.3578 32.6422 15.2049 32.454 15.109C32.2401 15 31.9601 15 31.4 15H28.6C28.0399 15 27.7599 15 27.546 15.109C27.3578 15.2049 27.2049 15.3578 27.109 15.546C27 15.7599 27 16.0399 27 16.6V20"
              stroke="var(--blue-dark-500)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div>
            <h4 className="text-sm text-gray-600">Total Ads</h4>
            <h4 className="text-xl text-gray-900 font-bold  mt-2">
              {data?.total_ads_purchased ? data?.total_ads_purchased : "-"}
            </h4>
          </div>
        </div>
        <div className="w-full space-y-3">
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
              fill="var(--blue-dark-50)"
            />
            <path
              d="M28.5 26H28.51M15 17V31C15 32.1046 15.8954 33 17 33H31C32.1046 33 33 32.1046 33 31V21C33 19.8954 32.1046 19 31 19L17 19C15.8954 19 15 18.1046 15 17ZM15 17C15 15.8954 15.8954 15 17 15H29M29 26C29 26.2761 28.7761 26.5 28.5 26.5C28.2239 26.5 28 26.2761 28 26C28 25.7239 28.2239 25.5 28.5 25.5C28.7761 25.5 29 25.7239 29 26Z"
              stroke="var(--blue-dark-500)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div>
            <h4 className="text-sm text-gray-600">
              Monthly Google Ads Budget
            </h4>
            <h4 className="text-xl text-gray-900 font-bold mt-2">
              {data?.monthly_google_ads_budget ? (
                <>${data?.monthly_google_ads_budget}</>
              ) : (
                "-"
              )}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}
